//redux
import { useSelector } from 'react-redux';

//Router dom
import { useNavigate } from 'react-router-dom';

//MUI
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button)({
    backgroundColor: '#38B6FF',
    '&:hover': {
        backgroundColor: '#1FA3F0 '
    }
});

const AlertOrderNoCompleted = () => {
    const navigate = useNavigate();

    const {
        cart: {
            checkout: { skip }
        },
    } = useSelector(state => state.shop);

    return (
        <>
            {
                skip &&
                <Alert severity="info"
                    icon={
                        <ReceiptOutlinedIcon />
                    } 
                    // sx={{
                    //     backgroundColor: '#E3F6FF',
                    //     color: 'black',
                    //     '& .MuiAlert-icon': { color: '#0B3D91' }
                    // }}
                >
                    <AlertTitle sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                        ¡Tienes un PEDIDO PENDIENTE! Puedes continuar desde donde lo dejaste.
                    </AlertTitle>
                        {/* El pago de tu pedido está pendiente. Asegúrate de completarlo para procesar tu orden. */}
                        Podrás revisar tus productos antes de confirmar tu compra.
                    <Box sx={{ mt: 2 }}>
                        <CustomButton variant="contained"
                            onClick={() => navigate('/checkout-resumen')}>
                            Proceder al pago
                        </CustomButton>
                    </Box>
                </Alert>
            }
        </>
    );
};

export default AlertOrderNoCompleted;